var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm-sections"},[_c('section',{staticClass:"lm-sections_title"},[_vm._v(_vm._s(_vm.title))]),_c('ul',{staticClass:"lm-sections_list"},_vm._l((_vm.list),function(item,i){return _c('li',{key:i,staticClass:"lm-sections_item"},[_c('span',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }